import type { PanelMenuItem } from '@/components/base/panel-menu'

export interface GameMenuItem extends PanelMenuItem<GameMenuItem> {
  id?: number
  // Game 分类一定是 game 类型
  type: MenuType.Game
  value?: string
  gameType?: number
}

export type GameMenuList = GameMenuItem[]

export const enum MenuType {
  Game = 'game',
  Activity = 'activity'
}
// 顶部/底部菜单Item 类型
export type NoneGameMenuItem = PanelMenuItem<NoneGameMenuItem> & {
  // 没有子项时，hover后需要显示的提示语
  tip?: string
}
